//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_twoPi = 6.283185307179586;\n\
";
